//import React, { useState } from 'react';
import axios from 'axios'
import { useFormik } from 'formik';
import './styles/form.css'
import * as Yup from 'yup'
//import { loadProgressBar } from 'x-axios-progress-bar'
import 'x-axios-progress-bar/dist/nprogress.css'
import { useNavigate } from 'react-router-dom';


//const port=process.env.REACT_APP_PORT2
const baseUrl= process.env.REACT_APP_HOST

const CreateNewUser=()=>{
    let navigate = useNavigate();
    const routeChange = () =>{
        let path = `/MasterForm`;
        navigate(path);
    };
    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            firstName: Yup.string().max(30, 'Please enter a first name with 30 characters max.').required('First name is Required.'),
            lastName: Yup.string().max(30, 'Please enter a last name with 30 characters max.').required('Last name is Required.'),
            email: Yup.string().email().max(30, 'Please enter an email with 30 characters max.').required('Email is Required.'),
            password: Yup.string().max(20, 'Please enter a password that is 20 characters or less.').required('Password is Required.'),
        }),
        onSubmit: values => {
            axios.post(baseUrl + "createNewUser", values).then((response) => {
                if (response.data === "User already exists"){
                    console.log(response.data)
                    alert("That User Email already exists, please register with a different email.")
                }else{
                    alert('Success: New User Created!');
                    routeChange();
                }
            })
            .catch((error) => {
                if(error.response) {
                    console.log("CREATE NEW USER: " + error.repsonse);
                    alert('Something went wrong: New User Not Created.');
                } else if (error.request) {
                    console.log("CREATE NEW USER: " + error.request);
                    alert('Something went wrong: New User Not Created.');
                } else {
                    console.log("CREATE NEW USER: " + error);
                    alert('Something went wrong: New User Not Created.');
                }
            });
        },
    })

        return(
            <div class="App">

                <img class="logo" src="Logo_square.jpeg" alt="" ></img> 
               
                <div align="center">
                <form onSubmit={ formik.handleSubmit }>
                    <legend>
                        Create New User
                    </legend>
                    <tr>
                        <td>
                        <label class="BasicInfoLabel">First Name</label>
                        </td>
                        <td class="BasicInput">
                        <input
                        id="firstName"
                        type="text"
                        name="firstName"
                        onChange={formik.handleChange}
                        value={formik.values.firstName}>
                        </input>
                        </td>
                    </tr>
                    {formik.touched.firstName && formik.errors.firstName ? (<div class="Error">{formik.errors.firstName}</div>) : null}
                    <tr>
                        <td>
                        <label class="BasicInfoLabel">Last Name</label>            
                        </td>
                        <td class="BasicInput">
                        <input
                        id="lastName" 
                        type="text"
                        name="lastName"
                        onChange={formik.handleChange}
                        value={formik.values.lastName}>
                        </input>
                        </td>
                    </tr>
                    {formik.touched.lastName && formik.errors.lastName ? (<div class="Error">{formik.errors.lastName}</div>) : null}
                    <tr>
                        <td>
                        <label class="BasicInfoLabel">Email</label>
                        </td>
                        <td class="BasicInput">
                        <input
                        id="email" 
                        type="text"
                        name="email"
                        onChange={formik.handleChange}
                        value={formik.values.email}>
                        </input>
                        </td>
                    </tr>
                    {formik.touched.email && formik.errors.email ? (<div class="Error">{formik.errors.email}</div>) : null}
                    <tr>
                        <td>
                        <label clas="BasicInfoLabel">Password</label>
                        </td>
                        <td class="BasicInput">
                        <input
                        id="password" 
                        type="password"
                        name="password"
                        onChange={formik.handleChange}
                        value={formik.values.password}>
                        </input>
                        </td>
                    </tr>
                    {formik.touched.password && formik.errors.password ? (<div class="Error">{formik.errors.password}</div>) : null}
      
                <div align="center" class="mt-4">
                    <button type="button" class="btn btn-secondary mr-5" onClick={ routeChange }>Cancel</button>
                    <button type="submit" class="btn btn-success ">Submit</button>
                </div>
                </form>
                </div>
                </div>
    )
}
 
export default CreateNewUser;
